import { Col, Row } from "antd";
import { useNavigate } from "react-router";
import { useContext, useEffect } from "react";
import Layout from "../../layout/Layout";
import SettingsSidebar from "./SettingsSidebar";
import { AuthContext } from "../../context/AuthContext";
import "../../assets/css/settings.css";

const AdminContainer = ({ children }) => {
  const navigate = useNavigate();
  const { isAuthenticated } = useContext(AuthContext);

  useEffect(() => {
    if (!isAuthenticated) {
      navigate("/signin");
    }
  }, [isAuthenticated, navigate]);

  return (
    <Layout>
      <Row className="settings h-100 m-0">
        <Col xs={24} sm={24} md={6} lg={4}>
          <SettingsSidebar />
        </Col>
        <Col xs={24} sm={24} md={18} lg={20}>
          {children}
        </Col>
      </Row>
    </Layout>
  );
};

export default AdminContainer;
